import { useAppSelector } from "../redux/config/store";

export default function useTutorialMode() {
	const isTutorialMode = useAppSelector((state) => state.game.tutorialMode);

	return { isTutorialMode };
}